import { useEffect, useState } from "react";

import { validateUserLogin } from "./ValidateUserLogin.jsx";

export function useAuth() {
  const [authed, setAuthed] = useState(null);

  useEffect(() => {
    async function loadInitialData() {
      const isAuthed = await validateUserLogin();
      setAuthed(isAuthed);
    }

    loadInitialData().then();
  }, []);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      async function loadInitialData() {
        const isAuthed = await validateUserLogin();
        setAuthed(isAuthed);
      }

      loadInitialData().then();
    }, 600000);

    return () => clearTimeout(delayDebounceFn);
  }, [authed]);

  function logout() {
    localStorage.removeItem("username");
    localStorage.removeItem("passwordHash");
    localStorage.removeItem("apiKey");
    localStorage.removeItem("userLastVerified");
    setAuthed(false);
  }

  return {
    authed,
    onLogout() {
      return new Promise((res) => {
        logout();
        res();
      });
    },
  };
}
